import getConfig from 'next/config';
import { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import EirActionModal from '../eir-action-modal/EirActionModal';
import fetchInfo from '../../../util/fetchModalData';
import { clearLocalStorage } from '../../hooks/useLocalStorage';
import { clearAllCookies } from '../../hooks/useCookie';
import { displayCart } from '../eir-cart/cart.util';
import RootContext from '../../../util/root.context';
import { useToggle } from '../../hooks/useToggle';
import errorTrack from '../../../util/Genesys';

const { publicRuntimeConfig } = getConfig();
const EirWebchatModal = ({ enableWebChat }) => {
  const { dispatch } = useContext(RootContext);
  const router = useRouter();
  const confirmLogOut = useToggle(false);

  const handleLogOut = () => {
    window.localStorage.clear();
    clearLocalStorage();
    clearAllCookies();
    confirmLogOut.disable();
    dispatch({ type: 'SET_CART', payload: null });
    displayCart({
      dispatch,
      showCart: false,
    });
    dispatch({ type: 'ENABLE_LOGOUT', payload: false });
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_OPENCMS}`);
  };

  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);

  const handleChatNow = modalId => {
    errorTrack(modalId);
  };
  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'no_mobile_eligibility_modal',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getCmsData();
    clearAllCookies();
    localStorage.clear();
  }, []);

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={enableWebChat.value}
      handleClose={enableWebChat.disable}
      title={cmsCollectionData?.attributes?.title}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url}`}
      description={`${
        cmsCollectionData?.attributes?.firstHalfDescription
          ? cmsCollectionData?.attributes?.firstHalfDescription
          : ''
      }
    ${
      cmsCollectionData?.attributes?.secondHalfDescription
        ? cmsCollectionData?.attributes?.secondHalfDescription
        : ''
    }
    `}
      cta={[
        {
          // text: 'Chat now',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Chat now',
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
          type: 'solid',
          action: () => handleChatNow(cmsCollectionData?.attributes?.modalID),
        },
        {
          // text: 'Logout',
          text: cmsCollectionData?.attributes?.cta[1]?.name
            ? cmsCollectionData?.attributes?.cta[1]?.name
            : 'Logout',
          ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            : '',
          type: 'contained',
          action: () => handleLogOut(),
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
      load={load}
    />
  );
};
export default EirWebchatModal;
